import React from 'react'
import './MyModalCss.css'
import MessageIcon from '../../Icons/MessageIcon'
import intl from 'react-intl-universal'
export default function MyModal (props) {
  const visible = props.visible === false ? props.visible : true // 是否显示modal
  const title = props.title || intl.get('Tips') // 弹窗标题
  const info = props.info || intl.get('TipsContent') // 提示信息文本
  const titleStyle = props.titleStyle || {} // title的文本样式 默认为空
  const infoStyle = props.infoStyle || {} // 提示信息的文本样式 默认为空
  const wapperStyle = props.wapperStyle || {}
  const okButtonVisible = props.okButtonVisible === false ? props.okButtonVisible : true // 是否显示确认按钮 默认为true
  const cancelButtonVisible = props.cancelButtonVisible === false ? props.cancelButtonVisible : true // 是否显示取消按钮 默认为true
  const icon = props.Icon || <MessageIcon width={'60%'} height={'60%'} /> // 左侧icon
  const cancelButton = props.cancelButton || <div style={!okButtonVisible ? { width: '30%' } : {}} className={'cancelButton'}>{intl.get('Cancel')}</div> // 确定按钮组件
  const okButton = props.okButton || <div style={!cancelButtonVisible ? { width: '30%' } : {}} className={'okButton'}>{intl.get('OK')}</div> // 确定按钮组件
  // onOkClick: 点击确认按钮触发
  // onCancelClick: 点击取消按钮触发
  return (
    <div style={{ display: visible ? 'flex' : 'none' }} className={'myModalContainer'}>
      <div className={'myModalMask'} />
      <div className={'myModalMaskContent'} style={wapperStyle}>
        <div className={'myMenuModalMaskHead'}>
          <div className={'myModalMaskIcon'}>{icon}</div>
          <div style={titleStyle} className={'myModalMaskTitle'}>{title}</div>
        </div>
        <div style={infoStyle} className={'myMenuModalMaskInfo'}>{info}</div>
        <div className={'myMenuModalMaskButtons'}>
          <div
            style={{ display: okButtonVisible ? 'flex' : 'none' }}
            className={'okButtonContainer'}
            onClick={props.onOkClick}
          >
            {okButton}
          </div>
          <div
            style={{ display: cancelButtonVisible ? 'flex' : 'none' }}
            className={'cancelButtonContainer'}
            onClick={props.onCancelClick}
          >
            {cancelButton}
          </div>
        </div>
      </div>
    </div>
  )
}
